import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Tab, Tabs, Spinner, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
// import { QRCodeCanvas } from "qrcode.react";
import EditUser from "./EditUser";
import { url } from "../Components/url";
import { fetchWithAuth } from "../Components/FetchWithAuth";
import { UserContext } from "../Contexts/LoginContext";

import styles from "./UserProfile.module.scss";

function UserProfile() {
  const location = useLocation();
  const { username } = useContext(UserContext);
  const queryParams = new URLSearchParams(location.search);
  const requestedTab = queryParams.get("tab") === "settings" ? "Settings" : "Details";

  const { enquiry } = location.state || {};
  const [profileUser, setProfileUser] = useState(enquiry || null);
  const [isFetchingProfile, setIsFetchingProfile] = useState(false);
  const [showQR, setShowQR] = useState(false); // Control QR code visibility

  const isSelfProfile = !enquiry;

  useEffect(() => {
    const fetchCurrentUser = async () => {
      if (enquiry || !username) return;
      try {
        setIsFetchingProfile(true);
        const response = await fetchWithAuth(`${url}/get_user/${username}`, {
          method: "GET",
          credentials: "include",
        });
        const user = await response.json();
        setProfileUser(user);
      } catch (error) {
        setProfileUser(null);
      } finally {
        setIsFetchingProfile(false);
      }
    };
    fetchCurrentUser();
  }, [enquiry, username]);

  // Generate profile URL for QR code (adjust to your routing)
  const profileUrl = profileUser
    ? `${window.location.origin}/user/${profileUser.username}`
    : "";

  return (
    <div className={`${styles.pageContainer}`}>
        <div className={`${styles.contentCol} ${styles.tabsWrapper}`}>
            <Tabs
              defaultActiveKey={requestedTab}
              id="profile-tabs"
              className={styles.customTabs}
              justify
            >
              {/* Details Tab */}
              <Tab eventKey="Details" title="Details" tabClassName={styles.tabTitle}>
                <div className={styles.tabContent}>
                  {isFetchingProfile ? (
                    <div className={styles.spinnerContainer}>
                      <Spinner animation="border" variant="light" />
                    </div>
                  ) : (
                    <>
                      <EditUser data={profileUser} isSelfProfile={isSelfProfile} />

                      {/* QR Code Section (example) */}
                      {profileUser && (
                        <div className={styles.qrSection}>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => setShowQR(!showQR)}
                            className={styles.qrToggle}
                          >
                            {showQR ? "Hide QR Code" : "Show QR Code"}
                          </Button>
                          {showQR && (
                            <div className={styles.qrCode}>
                              {/* <QRCodeCanvas value={profileUrl} size={128} /> */}
                              <p className={styles.qrHint}>Scan to view profile</p>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </Tab>

              {/* Settings Tab */}
              <Tab eventKey="Settings" title="Settings" tabClassName={styles.tabTitle}>
                <div className={styles.tabContent}>
                  {isFetchingProfile ? (
                    <div className={styles.spinnerContainer}>
                      <Spinner animation="border" variant="light" />
                    </div>
                  ) : (
                    <EditUser
                      data={profileUser}
                      isSelfProfile={isSelfProfile}
                      activeTab="settings"
                    />
                  )}
                </div>
              </Tab>
            </Tabs>
          </div>
    </div>
  );
}

export default UserProfile;